<template>
  <d-modal
    :class="{ 'is-hidden': isHidden }"
    @close="handleClose">
    <d-modal-header>
      Zmień status zamówienia
    </d-modal-header>
    <d-modal-body>
      <validation-observer
        ref="order-status-form"
        tag="form">
        <label
          for="status"
          class="mr-1 mb-0 text-nowrap mb-2 mb-sm-0">
          Status zamówienia:
        </label>
        <validation-provider
          name="status"
          rules="required"
          v-slot="{ errors }">
          <div
          :class="{
            'form-control': true,
            'is-select': true,
            'is-invalid': errors.length,
            'vs-wrap-text': true
          }">
            <v-select
              :options="orderStatuses"
              :reduce="(status) => status.status_code"
              v-model="currentStatus"
              placeholder="Status zamówienia"
              :clearable="false"
              :searchable="false"
              label="label">
            </v-select>
          </div>
          <div class="invalid-feedback">
            {{ errors[0] }}
          </div>
        </validation-provider>
      </validation-observer>
    </d-modal-body>
    <d-modal-footer>
      <d-button
        class="ml-0"
        theme="danger"
        @click.prevent="cancel">
        Anuluj
      </d-button>
      <d-button
        class="ml-auto"
        theme="success"
        :disabled="submitInProgress"
        @click.prevent="submitStatus">
        <div
          v-if="submitInProgress"
          class="spinner-border spinner-border-sm"
          role="status">
        </div>
        Zapisz zmiany
      </d-button>
    </d-modal-footer>
  </d-modal>
</template>

<script>
import FormUtils from '@/utils/FormUtils.js';
import OrderStatuses from '@/data/order-statuses.js';

export default {
  name: 'order-status-change-popup',
  computed: {
    orderStatuses () {
      let orderStatusesArr = [];
      let keys = Object.keys(OrderStatuses)
      for (let i = 0; i < keys.length; i++) {
        let orderStatus = OrderStatuses[keys[i]];
        orderStatus['status_code'] = keys[i];
        orderStatusesArr.push(orderStatus);
      }
      return orderStatusesArr;
    }
  },
  data() {
    return {
      currentStatus: 'NEW',
      orderID: null,
      loadError: false,
      isStatusChanged: false,
      isHidden: true,
      submitInProgress: false
    };
  },
  mounted() {
    this.$bus.$on('show-order-status-change-popup', this.openPopup);
  },
  methods: {
    handleClose() {
      this.isHidden = true;
    },
    submitStatus () {
      let formDataToSend = {
        status: this.currentStatus
      };

      let endpointUrl = '/api/orders/add-status/' + this.orderID;

      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: 'Zapisano status',
        successText: 'Wybrany status został zapisany',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Modyfikacja statusu nie powiodła się. Spróbuj ponownie.',
        successAction: () => {
          this.handleClose();
          this.$bus.$emit('reload-orders');
        }
      });
    },
    openPopup(order) {
      this.orderID = order.id;
      this.currentStatus = order.status;

      setTimeout(() => {
        this.isHidden = false;
        if (this.$refs['order-status-form']) {
          this.$refs['order-status-form'].reset();
        }
      }, 0);
    },
    cancel() {
      this.handleClose();
    },
    closePopup() {
      this.submitInProgress = false;
      this.isHidden = true;
    }
  },
  beforeDestroy() {
    this.$bus.$off('show-order-status-change-popup', this.openPopup);
  }
};
</script>

<style lang="scss" scoped>
.modal.is-hidden {
  display: none;
  pointer-events: none;
}
</style>
